export const DEFAULT_BENEFIT = {
  admin_copay: "$",
  admin_coverage: "%",
  deductible: "$",
  deductible_met: "$",
  med_ben_notes: "",
  office_copay: "$",
  office_coverage: "%",
  out_of_pocket_max: "$",
  out_of_pocket_met: "$",
  product_copay: "$",
  product_coverage: "%",
}
